import {
  Component,
  Input,
  TemplateRef,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
  selector: 'zef-state-switcher-state',
  templateUrl: './state-switcher-state.component.html',
  styleUrls: [ './state-switcher-state.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StateSwitcherStateComponent {

  // # Event Streams

  // # Forms

  // # Data
  // -- angular
  @Input()
  id: string;

  @Input()
  set default(v: string | boolean) {
    this._default = coerceBooleanProperty(v);
  }
  get default(): boolean { return this._default; }

  @ViewChild('templateRef', { static: true })
  templateRef: TemplateRef<any>;

  // -- async

  // # Action Streams

  private _default: boolean;
}
